import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../shared/components/table/Table";
import TableDeleteButton from "../../../../../shared/components/button/TableDeleteButton";

const CCSectionsPermissionsTable = ({ data, onDeletion }) => {
  return (
    <Table>
      <TableHeader>
        <TableHead>Identificador</TableHead>
        <TableHead>Título</TableHead>
        <TableHead>Nombre</TableHead>
        <TableHead></TableHead>
      </TableHeader>
      <TableBody>
        {data &&
          data.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.title}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>
                <TableDeleteButton onClickHandler={() => onDeletion(row.id)} />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default CCSectionsPermissionsTable;
